import { render, staticRenderFns } from "./MidBack.vue?vue&type=template&id=60ee9696&"
import script from "./MidBack.vue?vue&type=script&lang=js&"
export * from "./MidBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports